<button #dropDownButton *ngIf="data" class="search-dd-button" [disabled]="data.disabled"
    [ngClass]="{'search-dd-button-selected':isDropdownOpen||hasSelectedItems}" (click)="toggleDropdown()">
    <div class="nowrap text-capitalize filter-label label">{{title}}</div>
    <mat-icon>
        {{isDropdownOpen?'expand_less':'expand_more'}}</mat-icon>
</button>
